import useNameField from './useNameField'
import useGenerateCouponCode from './useGenerateCouponCode'
import useHeaderBtns from './useHeaderBtns'
import useColumns from './useColumns'

export { useGenerateCouponCode }
export default { useColumns, useNameField, useHeaderBtns }